import { SidebarTitle } from '../../MeetingSummary/Sidebar/models'
import React, { useEffect, useState } from 'react'
import { Notepad } from '../../MeetingSummary/Notepad/Notepad'
import { useAppSelector } from '../../../../../store/hooks'
import { Collapse, Stack } from 'react-bootstrap'
import classNames from 'classnames'
import {
  HeaderResultOption,
  HeaderResultOptionsButton,
} from '../../MeetingSummary/MeetingResults/ResultCard/Header/HeaderResultOptions/HeaderResultOptionsButton'
import { IntegrationServiceId } from '../../../../../common/integrations'
import { selectMeetingNote, selectMeetingNoteUpdateIsLoading } from '../../../../../store/meetingSummary/meetingSupport'
import { getHtmlContentFromState } from '../../MeetingSummary/MeetingResults/Lexical/utils'
import { AddNoteToCRMModal } from '../../../../../views/MeetingSummary/CRM/V2/AddNoteToCRMModal'
import { useAddMeetingInfoNotepadResultOption, useCopyNotepadResultOption } from './NotepadResultOptions'
import './Notepad.scss'

const SAVING = 'Saving…'
const SAVED = 'Saved ✓'

export const NotepadComponent: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false)
  const [selectedIntegration, setSelectedIntegration] = useState<IntegrationServiceId | null>(null)
  const meetingNote = useAppSelector(selectMeetingNote)
  const htmlContent = meetingNote ? getHtmlContentFromState(meetingNote) : ''
  const isMeetingNoteUpdateLoading = useAppSelector(selectMeetingNoteUpdateIsLoading)
  const [saveText, setSaveText] = useState<string>('')

  const resultOptions = [useAddMeetingInfoNotepadResultOption(), useCopyNotepadResultOption()].filter(
    (resultOption): resultOption is HeaderResultOption => !!resultOption,
  )

  useEffect(() => {
    if (isMeetingNoteUpdateLoading) {
      setSaveText(SAVING)
    }
  }, [isMeetingNoteUpdateLoading])

  useEffect(() => {
    if (!saveText) {
      return
    }
    if (!isMeetingNoteUpdateLoading) {
      setSaveText(SAVED)
    }
  }, [saveText, isMeetingNoteUpdateLoading])

  useEffect(() => {
    if (!isMeetingNoteUpdateLoading) {
      const timeout = setTimeout(() => setSaveText(''), 2000)
      return () => clearTimeout(timeout)
    }
  }, [isMeetingNoteUpdateLoading])

  return (
    <>
      {!!selectedIntegration && (
        <AddNoteToCRMModal note={htmlContent} show={!!selectedIntegration} onHide={() => setSelectedIntegration(null)} serviceId={selectedIntegration} />
      )}
      <div className='d-flex flex-column border zocks-border-0.5'>
        <div className='d-flex p-4 align-items-center justify-content-between' onClick={() => setIsCollapsed(!isCollapsed)}>
          <div className='d-flex align-items-center gap-2'>
            <i className={`bi bi-journal-text`} />
            <div className='paragraph-large bold'>{SidebarTitle.NOTEPAD}</div>
          </div>
          <Stack direction='horizontal' gap={2}>
            <div className={classNames('paragraph-medium', { 'saved-text': saveText === SAVED })}>{saveText}</div>
            <div
              onClick={(event) => {
                event.stopPropagation()
              }}
            >
              <HeaderResultOptionsButton resultOptions={resultOptions} disabled={false} />
            </div>
            <i
              className={classNames('bi', {
                'bi-chevron-expand': isCollapsed,
                'bi-chevron-contract': !isCollapsed,
              })}
            />
          </Stack>
        </div>
        <Collapse in={!isCollapsed} dimension={'height'}>
          <div className='d-flex flex-column flex-grow-1 notepad-body'>{!isCollapsed ? <Notepad /> : null}</div>
        </Collapse>
      </div>
    </>
  )
}
